import { ApplicationView } from "@mixitone/mvc";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthController } from "../controllers/AuthController";
import Menu from "./Menu";

const ControlledAuthenticated: React.FC = () => {
  const controller = AuthController.use();
  const { loading, sessionChecked, authed } = controller.state;

  if (loading) {
    return <></>;
  }

  if (sessionChecked && !authed) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <Outlet />
      <Menu />
    </>
  );
};

const Authenticated = AuthController.scope(ApplicationView(ControlledAuthenticated));
export { Authenticated };

const ControlledMightBeAuthenticated: React.FC = () => {
  const controller = AuthController.use();
  const { loading, sessionChecked, authed } = controller.state;

  if (loading) {
    return <></>;
  }

  return (
    <>
      <Outlet />
      {sessionChecked && authed && <Menu />}
    </>
  );
};

const MightBeAuthenticated = AuthController.scope(ApplicationView(ControlledMightBeAuthenticated));
export { MightBeAuthenticated };
